<template>
  <div class="contentBox" >
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 删除提示框 -->
    <div class="msgBox removeBox" v-if="removeType">
      <div class="contv">
        <p class="title">提示</p>
        <p class="txt" v-if="topicNum>0">确认删除{{topicNum}}条数据吗？</p>
        <p class="txt" v-else>确认删除吗？</p>
        <div class="btnBox">
          <button class="btn btn-remove" @click="removeSub">删除</button>
          <button class="btn btn-close" @click="removeHide">取消</button>
        </div>
      </div>
    </div>

    <!-- 关联考试 -->
    <div class="msgBox tipsBox" v-if="associationType">
      <div class="contv">
        <p class="title">关联考试</p>
        <p class="txt">已选中题目数量：{{topicNum}}个</p>
        <div class="name">
          <p>考试名称：</p>
          <select>

          </select>
        </div>
        <div class="btnBox">
          <button class="btn btn-sub" @click="">删除</button>
          <button class="btn btn-close" @click="">取消</button>
        </div>
      </div>
    </div>

    <!-- 查看详情 -->
    <div class="msgBox detailBox" v-if="detailType">
      <div class="contv">
        <p class="title">查看详情</p>
        <div class="scroll">
          <div class="detail">
            <p>题目ID：{{detailData.topic_id}}</p>
            <p>题型：{{detailData.topic_type==1?'单选题':detailData.topic_type==2?'多选题':detailData.topic_type==3?'判断题':'案例题'}}</p>
            <p v-if="detailData.topic_type!=3">选项个数：{{detailData.option_num}}个</p>
            <div class="topic">
              <div class="topic-item">
                <p class="topic-title">题干：{{detailData.topic_title}}</p>
                <div class="optins">
                  <p v-if="detailData.option_A">A.{{detailData.option_A}}</p>
                  <p v-if="detailData.option_B">B.{{detailData.option_B}}</p>
                  <p v-if="detailData.option_C">C.{{detailData.option_C}}</p>
                  <p v-if="detailData.option_D">D.{{detailData.option_D}}</p>
                  <p v-if="detailData.option_E">E.{{detailData.option_E}}</p>
                  <p v-if="detailData.option_F">F.{{detailData.option_F}}</p>
                  <p v-if="detailData.option_G">G.{{detailData.option_G}}</p>
                  <p v-if="detailData.option_H">H.{{detailData.option_H}}</p>
                </div>
                <p v-if="detailData.topic_type==1">正确答案：{{detailData.answer}}</p>
                <p v-if="detailData.topic_type==2">正确答案：
                  <span v-for="(item,index) in detailData.answer" v-bind:key="index">{{item}}</span>
                </p>
                <p v-if="detailData.topic_type==3">正确答案：{{detailData.answer==1?'正确':'错误'}}</p>
                <p>题目解析：{{detailData.analysis}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="btnBox">
          <button class="btn btn-sub" @click="detailHide">确认</button>
        </div>
      </div>
    </div>

    <!-- 单题导入 -->
    <div class="content content1 danti" v-if="singleType">
      <myHeader></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>题目管理/单题导入</p>
        </div>
        <div class="organiza-form">
          <form>
            <div class="form-txt">
              <p class="title">章节：</p>
              <div class="txt">
                <select v-model="addObj.cert_num">
                  <option value="">请选择章节</option>
                  <option :value="item" v-for="item in chapterNum" v-bind:key="item">{{item}}</option>
                </select>
              </div>
            </div>
            <div class="form-txt">
              <p class="title">题型：</p>
              <div class="txt">
                <select v-model="addObj.topic_type" @change="topicChange" :disabled="singleType=='edit'?true:false">
                  <option value="">请选择题型</option>
                  <option :value="item.id" v-for="item in singleTopic" v-bind:key="item.id" >{{item.title}}</option>
                </select>
                <span class="msg-txt" v-if="addObj.topic_type == 4">单个案例素材下必须有10道小题，小于或大于10道题则无法提交</span>
              </div>
            </div>
            <div class="form-txt"  v-if="addObj.topic_type == 4 || addObj.content">
              <p class="title">案例素材：</p>
              <div class="txt">
                <textarea v-model="topicObj.content"></textarea>
              </div>
              <div class="btn btn-choose" @click="getContent">选择已有素材</div>
            </div>
            <div class="" v-if="addObj.topic_type == 4">
              <div v-for="(item,index) in topicObj.topics" :key="(index+1)" style="border-bottom: solid 1px #ccc;margin-bottom: 10px;">
                <div class="form-txt">
                  <p class="title">题型：</p>
                  <div class="txt">
                    <select v-model="item.topic_type" @change="topicChange('anli',index)">
                      <option value="">请选择题型</option>
                      <option :value="item.id" v-for="item in singleTopic" v-bind:key="item.id" v-if="item.id<4">{{item.title}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-txt">
                  <p class="title">题干：</p>
                  <div class="txt">
                    <textarea v-model="item.topic_title"></textarea>
                  </div>
                </div>
                <div class="form-txt" v-if="item.topic_type != 3">
                  <p class="title">选项个数：</p>
                  <div class="txt">
                    <select @change="optionsChange($event,index)" v-model="item.option_num">
                      <option value="">请选择个数</option>
                      <option :value="item" v-for="item in 8" v-bind:key="item">{{item}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-options">
                  <div class="form-txt" v-if="item.option_A || item.option_A == ''">
                    <p class="title">选项A：</p>
                    <div class="txt">
                      <textarea v-model="item.option_A" :maxlength="30"></textarea>
                    </div>
                  </div>
                  <div class="form-txt" v-if="item.option_B || item.option_B == ''">
                    <p class="title">选项B：</p>
                    <div class="txt">
                      <textarea v-model="item.option_B" :maxlength="30"></textarea>
                    </div>
                  </div>
                  <div class="form-txt" v-if="item.option_C || item.option_C == ''">
                    <p class="title">选项C：</p>
                    <div class="txt">
                      <textarea v-model="item.option_C" :maxlength="30"></textarea>
                    </div>
                  </div>
                  <div class="form-txt" v-if="item.option_D || item.option_D == ''">
                    <p class="title">选项D：</p>
                    <div class="txt">
                      <textarea v-model="item.option_D" :maxlength="30"></textarea>
                    </div>
                  </div>
                  <div class="form-txt" v-if="item.option_E || item.option_E == ''">
                    <p class="title">选项E：</p>
                    <div class="txt">
                      <textarea v-model="item.option_E" :maxlength="30"></textarea>
                    </div>
                  </div>
                  <div class="form-txt" v-if="item.option_F || item.option_F == ''">
                    <p class="title">选项F：</p>
                    <div class="txt">
                      <textarea v-model="item.option_F" :maxlength="30"></textarea>
                    </div>
                  </div>
                  <div class="form-txt" v-if="item.option_G || item.option_G == ''">
                    <p class="title">选项G：</p>
                    <div class="txt">
                      <textarea v-model="item.option_G" :maxlength="30"></textarea>
                    </div>
                  </div>
                  <div class="form-txt" v-if="item.option_H || item.option_H == ''">
                    <p class="title">选项H：</p>
                    <div class="txt">
                      <textarea v-model="item.option_H" :maxlength="30"></textarea>
                    </div>
                  </div>
                </div>
                <div class="form-txt" v-if="item.topic_type == 2">
                  <p class="title">正确答案：</p>
                  <div class="txt">
                    <el-checkbox v-for="(ele,num) in item.optionsData" v-bind:key="ele.id" v-model="ele.checked">{{ele.value}}</el-checkbox>
                  </div>
                </div>

                <div class="form-txt" v-else>
                  <p class="title">正确答案：</p>
                  <div class="txt" v-if="item.topic_type == 1 || item.topic_type == 4">
                    <el-radio-group v-for="items in optionsData" v-bind:key="items.id" v-model="item.answer">
                      <el-radio :label="items.value">{{items.value}}</el-radio>
                    </el-radio-group>
                  </div>

                  <div class="txt" v-else>
                    <el-radio-group v-model="item.answer">
                      <el-radio label="1">正确</el-radio>
                      <el-radio label="0">错误</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="form-txt">
                  <p class="title">题目解析：</p>
                  <div class="txt">
                    <textarea v-model="item.analysis"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="" v-else>
              <div class="form-txt">
                <p class="title">题干：</p>
                <div class="txt">
                  <textarea v-model="addObj.topic_title"></textarea>
                </div>
              </div>
              <div class="form-txt" v-if="addObj.topic_type!=3">
                <p class="title">选项个数：</p>
                <div class="txt">
                  <select @change="optionsChange($event)" v-model="addObj.option_num">
                    <option value="">请选择个数</option>
                    <option :value="item" v-for="item in 8" v-bind:key="item">{{item}}</option>
                  </select>
                </div>
              </div>
              <div class="form-options" v-if="addObj.topic_type!=3">
                <div class="form-txt" v-for='item in optionsData' v-bind:key="item.id">
                  <p class="title">选项{{item.value}}：</p>
                  <div class="txt">
                    <textarea v-model="item.topic" :maxlength="30"></textarea>
                  </div>
                </div>
              </div>

              <div class="form-txt" v-if="addObj.topic_type == 2">
                <p class="title">正确答案：</p>
                <div class="txt">
                  <el-checkbox v-for="item in optionsData" v-bind:key="item.id" v-model="item.checked">{{item.value}}</el-checkbox>
                </div>
              </div>

              <div class="form-txt" v-else>
                <p class="title">正确答案：</p>
                <div class="txt" v-if="addObj.topic_type == 1 || addObj.topic_type == 4">
                  <el-radio-group v-for="item in optionsData" v-bind:key="item.id" v-model="addObj.answer">
                    <el-radio :label="item.value">{{item.value}}</el-radio>
                  </el-radio-group>
                </div>

                <div class="txt" v-else>
                  <el-radio-group v-model="addObj.answer">
                    <el-radio label="1">正确</el-radio>
                    <el-radio label="0">错误</el-radio>
                  </el-radio-group>
                </div>
              </div>

              <div class="form-txt">
                <p class="title">题目解析：</p>
                <div class="txt">
                  <textarea v-model="addObj.analysis"></textarea>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="btnBox">
        <button class="btn btn-add" @click="addTopic" v-if="addObj.topic_type == 4">添加题目</button>
        <button class="btn btn-sub" @click="singleSub">提交</button>
        <button class="btn btn-close" @click="singleHide">取消</button>
      </div>
    </div>

    <!-- 批量导入 word-->
    <div class="content content1 piliang " :class="multipleType=='word'?'':'hide'">
      <myHeader></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>题目管理/批量导入</p>

          <div class="fileType hide">
            <span class="select" @click="fileSub('word')">Word</span>
            <span @click="fileSub('excel')">EXCEL</span>
          </div>
        </div>
        <div class="organiza-form">
          <form>
            <div class="form-txt">
              <p class="title">选择章节：</p>
              <div class="txt">
                <select v-model="fileObj.cert_num">
                  <option value="">请选择章节</option>
                  <option :value="item" v-for="item in chapterNum" v-bind:key="item">{{item}}</option>
                </select>
              </div>
            </div>
            <div class="file">
              <div class="form-txt">
                <p class="title" style="display: inline-block">第1步：</p>
                <!-- <div class="txt">
                  <a @click="updown">EXCEL模板</a>
                </div> -->
                <select v-model="word_topicType">
                  <option value="">请选择题型</option>
                  <option :value="item.id" v-for="item in singleTopic" v-bind:key="item.id" >{{item.title}}</option>
                </select>
                <span class="msg-txt" v-if="word_topicType == 4">单个案例素材下必须有10道小题，小于或大于10道题则无法提交</span>
                <!-- <div class="btn btn-revise" @click="templateDetail('revise')">点击修改模版</div> -->
              </div>
              <div class="form-txt">
                <p class="title">第2步：填写模板</p>
                
                <div class="btn btn-write" v-if="fileObj.cert_num" @click="templateDetail('write')">点击填写模版</div>
                <p class="title" v-else>请先选择章节</p>
              </div>
              <div class="form-txt" v-loading="loading">
                <p class="title">第3步：上传文档</p>
                <div class="txt" v-if="fileObj.cert_num && templateObj.cert_id">
                  <el-upload
                    v-if="word_topicType == 4"
                    class="upload-demo"
                    drag
                    accept=".docx,.doc"
                    :headers="{'userToken':token}"
                    :on-success="handleSuccess"
                    :data="templateObj"
                    :before-upload="handleBefore"
                    :on-error="handleError"
                    :action="url+'/org/topic/importWordBigTopic'"
                    >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text" >将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                  <el-upload
                    v-else
                    class="upload-demo"
                    drag
                    accept=".docx,.doc"
                    :headers="{'userToken':token}"
                    :on-success="handleSuccess"
                    :data="templateObj"
                    :before-upload="handleBefore"
                    :action="url+'/org/topic/importWordTopic'"
                    >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text" >将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </div>
                <p class="title" v-else>请先选择章节，填写模板</p>
                
              </div>
            </div>
            <div class="form-txt">
              <p class="title" style="color:#457AFF" @click="explainShow">上传说明和格式案例</p>
            </div>
          </form>
        </div>
      </div>
      <div class="btnBox">
        <button class="btn btn-preview" @click="previewSub">预览</button>
        <button class="btn btn-sub" @click="topicSub">提交</button>
        <button class="btn btn-close" @click="multipleType=false;">取消</button>
      </div>
    </div>

    <!--批量导入 EXCEL模板 -->
    <div class="content content1 piliang hide" :class="multipleType=='excel'?'':'hide'">
      <myHeader></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>题目管理/批量导入</p>
          <div class="fileType">
            <span @click="fileSub('word')">Word</span>
            <span class="select" @click="fileSub('excel')">EXCEL</span>
          </div>
        </div>
        <div class="organiza-form">
          <form>
            <div class="form-txt">
              <p class="title">选择章节：</p>
              <div class="txt">
                <select v-model="fileObj.cert_num">
                  <option value="">请选择章节</option>
                  <option :value="item" v-for="item in chapterNum" v-bind:key="item">{{item}}</option>
                </select>
              </div>
            </div>
            <div class="file">
              <div class="form-txt">
                <p class="title">第1步：</p>
                <div class="txt">
                  <a @click="updown">EXCEL模板</a>
                </div>
              </div>
              <div class="form-txt">
                <p class="title">第2步：根据模版修改试题格式</p>
              </div>
              <div class="form-txt" v-loading="loading">
                <p class="title">第3步：上传文档</p>
                <div class="txt" v-if="fileObj.cert_num">
                  <el-upload
                    class="upload-demo"
                    drag
                    accept=".xls, .xlsx"
                    :headers="{'userToken':token}"
                    :on-success="handleSuccess"
                    :data="fileObj"
                    :before-upload="handleBefore"
                    :action="url+'/org/topic/importExcelTopic'"
                    >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text" >将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </div>
                <p class="title" v-else>请先选择章节</p>
                
              </div>
            </div>
            <div class="form-txt">
              <p class="title" style="color:#457AFF" @click="explainShow">上传说明和格式案例</p>
            </div>
          </form>
        </div>
      </div>
      <div class="btnBox">
        <button class="btn btn-preview" @click="previewSub">预览</button>
        <button class="btn btn-sub" @click="topicSub">提交</button>
        <button class="btn btn-close" @click="multipleType=false;">取消</button>
      </div>
    </div>

    <!-- 预览 -->
    <div class="content previewBox" v-if="previewType">
      <myHeader></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>题目管理/批量导入/预览</p>
          <div class="btnBox" style="float: right;">
            <button class="btn btn-back" @click="backSub">返回</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in previewTitle" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in previewData" v-bind:key="(index+1)">
              <p :title="item.topic_type==1?'单选题':item.topic_type==2?'多选题':'判断题'">{{item.topic_type==1?'单选题':item.topic_type==2?'多选题':'判断题'}}</p>
              <p :title="item.key">{{item.key}}</p>
              <p class="list-topic" :title="item.topic_title"> 
                {{item.topic_title}}<br>
                <span v-if="item.option_A">A.{{item.option_A}}</span>
                <span v-if="item.option_B">B.{{item.option_B}}</span>
                <span v-if="item.option_C">C.{{item.option_C}}</span>
                <span v-if="item.option_D">D.{{item.option_D}}</span>
                <span v-if="item.option_E">E.{{item.option_E}}</span>
                <span v-if="item.option_F">F.{{item.option_F}}</span>
                <span v-if="item.option_H">G.{{item.option_H}}</span>
                <span v-if="item.option_G">H.{{item.option_G}}</span>
              </p>
              <p v-if="item.topic_type==1">{{item.answer}}</p>
              <p v-if="item.topic_type==3">{{item.answer == 0 ? '错误' : item.answer == 1 ? '正确' : item.answer}}</p>
              <p v-if="item.topic_type==2">
                <span v-for="ele in item.answer" v-bind:key="ele">{{ele}}</span>
              </p>
              <p :title="item.analysis">{{item.analysis}}</p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChangePreview"
              :current-page.sync="previewObj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="previewPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="searchBox">
        <div class="search-item">
          <p>题目/题干ID：</p>
          <input type="text" placeholder="请输入要搜索的题目或题干ID" v-model="obj.title">
        </div>
        <div class="search-item">
          <p>题型：</p>
          <select v-model="obj.topic_type">
            <option value="">请选择题型</option>
            <option :value="item.id" v-for="item in singleTopic" v-bind:key="item.id" v-if="item.id<4">{{item.title}}</option>
          </select>
        </div>
        <div class="search-item">
          <p>章节：</p>
          <select v-model="obj.cert_num">
            <option value="">请选择章节</option>
            <option :value="item" v-for="item in chapterNum" v-bind:key="item">{{item}}</option>
          </select>
        </div>
        <div class="btnBox">
          <button class="btn btn-search" @click="searchSub">搜索</button>
          <button class="btn btn-reset" @click="resetSub">重置</button>
        </div>
      </div>
      <div class="organiza-txt" style="overflow: hidden;">
        <div class="organiza-title clear">
          <p>题目管理</p>
          <div class="btnBox">
            <button class="btn btn-batch2" v-if="publish_status=='false'" @click="removeShow('multiple')">批量删除</button>
            <button class="btn btn-batch3" @click="singleShow">单题导入</button>
            <button class="btn btn-batch3" @click="multipleShow()">批量导入</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p>
                <el-checkbox v-model="item.check"></el-checkbox>
              </p>
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.topic_id">{{item.topic_id}}</p>
              <p :title="item.topic_title">{{item.topic_title}}</p>
              <p :title="item.content?'案例题':item.topic_type==1?'单选题':item.topic_type==2?'多选题':item.topic_type==3?'判断题':'案例题'">{{item.content?'案例题':item.topic_type==1?'单选题':item.topic_type==2?'多选题':item.topic_type==3?'判断题':'案例题'}}</p>
              <p v-if="item.topic_type==1">{{item.answer}}</p>
              <p v-else>
                <span v-for="(ele,num) in item.answer" v-bind:key="num">{{ele}}</span>
              </p>
              <!-- <p v-if="item.topic_type==3">{{item.answer}}</p> -->
              <p :title="item.is_analysis==0?'否':'是'">{{item.is_analysis==0?'否':'是'}}</p>
              <p :title="item.cert_num">{{item.cert_num}}</p>
              <p style="color:#4C7EFB;" @click="detailSub(item)">详情</p>
              <p style="color:#FF7543;" @click='editShow(item)' v-if="publish_status=='false'">编辑</p>
              <p style="color:#FF5156;" @click="removeShow('one',item)" v-if="publish_status=='false'">删除</p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

     <!-- 上传格式说明 -->
     <div class="msgBox tipsBox" v-if="explainType">
      <div class="contv" style="text-align:left;height:80%;">
        <div class="scroll" style="overflow-y: auto;overflow-x: hidden;height:90%;width:100%;padding:10px">
          <p class="title">上传说明 ：</p>
          <div class="text">
            1.所有题型标号支持1.或1、两种格式。<br>
            2.所有题型必须含有 “答案：”字段，且不能为空。<br>
            3.所有题型 “ 解析：” 字段非必需，没有可不填。<br>
            4.选择题最少支持2个选项A、B，最多支持8个选项A、B、C、D、E、F、G、H且按照顺序使用。<br>
            5.选择题A-H这些选项号与内容之间要用、或 . 分开。<br>
            6.选择题答案中请勿加分隔符或者空格。<br>
            7.判断题答案支持 “错误”，“正确”或者 “错”，“对”。
          </div>
          <p class="title" style="margin-top:40px">格式案例：</p>
          <div class="text">
            1.驾驶人有下列哪种违法行为一次记6分？<br>
            A、使用其他车辆行驶证<br>
            B、饮酒后驾驶机动车<br>
            C、车速超过规定时速50%以上<br>
            D、违法占用应急车道行驶<br>
            答案：D<br>
            解析：请仔细阅读交规 (若无解析本行可不填)<br>
            2.驾驶人有下列哪种违法行为一次记6分？<br>
            A、使用其他车辆行驶证<br>
            B、饮酒后驾驶机动车<br>
            C、车速超过规定时速50%以上<br>
            D、违法占用应急车道行驶<br>
            答案：ABCD<br>
            解析：请仔细阅读交规 (若无解析本行可不填)
          </div>
        </div>
        <div class="btnBox" style="text-align:center;margin-top:30px;">
          <button class="btn btn-sub" @click="explainType=false;">确认</button>
        </div>
      </div>
    </div>


    <div class="msgBox tipsBox templateBox" v-if="templateType">
      <div class="contv">
        <p class="title">请填写模版</p>
        <div class="writeBox">
          <div class="write-item" v-if="word_topicType == 4">
            <p>案例：</p>
            <div class="template-data start">
              <p>开始</p>
              <div>
                <el-input v-model="large_section_start" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="template-data end">
              <p>结束</p>
              <div>
                <el-input v-model="large_section_end" placeholder="请输入内容"></el-input>
              </div>
            </div>

            <span>注：根据开始和结束分割文档</span>
          </div>
          <div class="write-item" v-else>
            <p>大段：</p>
            <div class="template-data start">
              <p>开始</p>
              <div>
                <el-input v-model="large_section_start" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="template-data end">
              <p>结束</p>
              <div>
                <el-input v-model="large_section_end" placeholder="请输入内容"></el-input>
              </div>
            </div>

            <span>注：根据开始和结束分割文档</span>
          </div>
          <div class="write-item" v-if="word_topicType == 4">
            <p>案例素材：</p>
            <div class="template-data start">
              <p>开始</p>
              <div>
                <el-input v-model="material_start" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="template-data end">
              <p>结束</p>
              <div>
                <el-input v-model="material_end" placeholder="请输入内容"></el-input>
              </div>
            </div>

            <span>注：根据开始和结束分割文档</span>
          </div>
          

          <div class="write-item">
            <p>{{word_topicType == 4?'题目至解析':'题目至答案'}}：</p>
            <div class="template-data start">
              <p>开始</p>
              <div>
                <el-input v-model="subject_start" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="template-data end">
              <p>结束</p>
              <div>
                <el-input v-model="subject_end" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <span>注：根据开始和结束分割文档</span>
          </div>

          <div class="write-item">
            <p>题目类型：</p>
            <div class="template-data start">
              <p>开始</p>
              <div>
                <el-input v-model="topic_mold_start" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="template-data end">
              <p>结束</p>
              <div>
                <el-input v-model="topic_mold_end" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <span>注：根据开始和结束匹配类型</span>
          </div>

          <div class="write-item">
            <p>难度：</p>
            <div class="template-data start">
              <p>开始</p>
              <div>
                <el-input v-model="difficulty_start" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="template-data end">
              <p>结束</p>
              <div>
                <el-input v-model="difficulty_end" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <span>注：根据开始和结束截取之间的数据</span>
          </div>

          <div class="write-item">
            <p>分数：</p>
            <div class="template-data start">
              <p>开始</p>
              <div>
                <el-input v-model="score_start" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="template-data end">
              <p>结束</p>
              <div>
                <el-input v-model="score_end" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <span>注：根据开始和结束截取之间的数据</span>
          </div>

          <div class="write-item">
            <p>题干：</p>
            <div class="template-data start">
              <p>开始</p>
              <div>
                <el-input v-model="title_start" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="template-data end">
              <p>结束</p>
              <el-autocomplete
                v-model="title_end"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入内容"
                @select="handleSelect"
              ></el-autocomplete>
            </div>
            <span>注：根据开始和结束截取之间的数据</span>
          </div>

          <div class="write-item">
            <p>选项：</p>
            <div class="template-data start" style="width: 450px;">
              <el-select v-model="value1" multiple placeholder="请选择" style="width: 100%;" @change="optionSub">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>


          <div class="write-option" v-if="template_options.length > 0">
            <div class="write-item" v-for="(item,index) in template_options" v-bind:key="index">
              <p>{{item.title}}：</p>
              <div class="template-data start">
                <p>开始</p>
                <div>
                  <el-input v-model="item.start" placeholder="请输入内容"></el-input>
                </div>
              </div>
              <div class="template-data end">
                <p>结束</p>
                <div>
                  <el-input v-model="item.end" placeholder="请输入内容"></el-input>
                </div>
              </div>
              <span>注：根据开始和结束截取之间的数据</span>
            </div>

            <div class="write-item">
              <p>答案：</p>
              <div class="template-data start">
                <p>开始</p>
                <div>
                  <el-input v-model="answer_start" placeholder="请输入内容"></el-input>
                </div>
              </div>
              <div class="template-data end">
                <p>结束</p>
                
                <el-autocomplete
                  v-model="answer_end"
                  :fetch-suggestions="querySearchAsync1"
                  placeholder="请输入内容"
                  @select="handleSelect"
                ></el-autocomplete>
              </div>
              <span>注：根据开始和结束截取之间的数据</span>
            </div>

            <div class="write-item">
              <p>解析：</p>
              <div class="template-data start">
                <p>开始</p>
                <div>
                  <el-input v-model="analysis_start" placeholder="请输入内容"></el-input>
                </div>
              </div>
              <div class="template-data end">
                <p>结束</p>
                <div>
                  <el-input v-model="analysis_end" placeholder="请输入内容"></el-input>
                </div>
              </div>
              <span>注：根据开始和结束截取之间的数据</span>
            </div>

          </div>
        </div>

        <div class="btnBox">
          <button class="btn btn-sub" @click="templateClose">确定</button>
          <button class="btn btn-close" @click="templateHide">取消</button>
        </div>
      </div>
    </div>


    <!-- 选择已有素材 -->
     <div class="msgBox tipsBox materialBox" v-if="materialType">
        <div class="contv">
          <p class="title">选择已有素材</p>
          <div class="list">
            <div class="list-item" :class="item.big_topic_id == topicObj.big_topic_id?'select':''" v-for="(item,index) in materialData" :key="(index+1)" @click="materialSub(item)">
              <p>{{item.content}}</p>
            </div>
          </div>
          <div class="btnBox">
            <button class="btn btn-sub" @click="materialHide">确定</button>
            <button class="btn btn-close" @click="materialHide">取消</button>
          </div>
        </div>
     </div>
  </div>
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getTopicList,saveTopic,delTopic,batchDelTopic,getTopicDetail,preview,submitImport,importWordTopic ,getOpenTopicSetList,getBigTopicList,addBigTopic,updateBigTopic } from "@/assets/js/api";
export default {
  name: "topic-index",
  data() {
    return {
      fileUrl:'/static/topic_template.xlsx',
      navId:'1',
      childrenID:'1-2',
      titleList:[
        {id:1,title:''},
        {id:2,title:'序号'},
        {id:3,title:'题目ID'},
        {id:4,title:'题干'},
        {id:5,title:'题型'},
        {id:6,title:'答案'},
        {id:7,title:'解析'},
        {id:8,title:'章节'},
      ],
      dataList:[],
      removeType:false,
      topicNum:0,
      topicType:[
        {id:1,title:'单选题'},
        {id:2,title:'多选题'},
        {id:3,title:'判断题'},
      ],
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      optionsList:[
        {id:1,value:'A',label:'option_A',topic:''},
        {id:2,value:'B',label:'option_B',topic:''},
        {id:3,value:'C',label:'option_C',topic:''},
        {id:4,value:'D',label:'option_D',topic:''},
        {id:5,value:'E',label:'option_E',topic:''},
        {id:6,value:'F',label:'option_F',topic:''},
        {id:7,value:'G',label:'option_G',topic:''},
        {id:8,value:'H',label:'option_H',topic:''},
      ],
      optionsData:[],
      explainType:false,
      previewTitle:[
        {id:1,title:'题型'},
        {id:2,title:'序号'},
        {id:3,title:'题目'},
        {id:4,title:'正确答案'},
        {id:5,title:'题目解析'},
      ],
      previewData:[],
      previewType:false,
      multipleType:false,
      singleType:false,
      detailType:false,
      detailData:'',
      associationType:false,
      answer:1,
      token:'',
      obj:{
        cert_id:'',
        page:1,
        rows:10,
        type:'1-2-2'
      },
      addObj:{
        cert_id:'',
        cert_num:'',
        topic_title:'',
        topic_type:'',
        answer:[],
        analysis:'',
      },
      totalPage:0,
      removeID:'',
      remove_ids:[],
      fileObj:{
        cert_id:'',
        cert_num:''
      },
      previewObj:{
        page:1,
        rows:10,
        file_name:'',
        cert_id:''
      },
      singleTopic:[],
      previewPage:0,
      textNum:0,
      publish_status:false,
      chapterNum:'',
      url:"",
      restaurants: [],
      state: '',
      timeout:  null,


      options: [{
        value: 'A',
        label: 'A'
      }, {
        value: 'B',
        label: 'B'
      }, {
        value: 'C',
        label: 'C'
      }, {
        value: 'D',
        label: 'D'
      }, {
        value: 'E',
        label: 'E'
      }, {
        value: 'F',
        label: 'F'
      }, {
        value: 'G',
        label: 'G'
      }],
      value1: [],
      templateType:false,
      template_options:[],
      templateObj:{
        cert_id:'',
        cert_num:'',
        large_section:['',''],
        subject:['',''],
        topic_mold:['',''],
        difficulty:['',''],
        score:['',''],
        title:['',''],
        answer:['',''],
        analysis:['','']
      },
      large_section_start:'',
      large_section_end:'',
      material_start:'',
      material_end:'',
      topic_mold_start:'',
      topic_mold_end:'',
      difficulty_start:'',
      difficulty_end:'',
      score_start:'',
      score_end:'',
      subject_start:'',
      subject_end:'',
      title_start:"",
      title_end:"",
      answer_start:"",
      answer_end:"",
      analysis_start:"",
      analysis_end:"",
      loading:false,
      topicObj:{},
      word_topicType:'',
      materialData:[],
      materialType:false,
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var that = this;
    this.token =this.$refs.navBox.userData.token;
    this.addObj.cert_id = this.$route.query.id;
    this.obj.cert_id = this.$route.query.id;
    this.fileObj.cert_id = this.$route.query.id;
    this.previewObj.cert_id = this.$route.query.id;
    this.publish_status = this.$route.query.publish_status;
    this.chapterNum = parseInt(this.$route.query.num);
    this.url = this.$refs.navBox.url;
    this.getList();
    getOpenTopicSetList(this.token).then((res)=>{
      var data = res.data;
      if(data.code == 200){
        that.singleTopic=[];
        data.data.forEach(function(item,index){
          if(item.topic_type==1){
            that.singleTopic.push({id:1,title:'单选题'});
          } else if(item.topic_type==2){
            that.singleTopic.push({id:2,title:'多选题'});
          } else if(item.topic_type==3){
            that.singleTopic.push({id:3,title:'判断题'});
          } else if(item.topic_type==4){
            that.singleTopic.push({id:4,title:'案例题'});
          };
        })
      } else {
        that.$message(data.msg);
      }
    })
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },
    handleCurrentChangePreview(val) {
      var that = this;
      preview(this.previewObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code==200){
          that.multipleType = false;
          that.previewType = true;
          that.previewData = data.data.list;
          that.previewData.forEach(function(item,index){
            if(item.topic_type == 2){
              item.answer = JSON.parse(item.answer);
            }
          });
          that.previewPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
    },

    

    updown(){
      var that = this;
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = that.fileUrl;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
      } catch (e) {
          that.$message('下载异常！')
      }
    },

    multipleShow(){
      // if(that.topicNum == 0){
      //   that.$message('请选择要删除的题目！');
      //   return false;
      // };x
      this.multipleType='word';
    },

    removeShow(type,e){
      var that = this;
      if(type=='multiple'){
        this.dataList.forEach(function(item,index){
          if(item.check){
            that.topicNum++;
            that.remove_ids.push(item.id);
          }
        });
        if(that.topicNum == 0){
          that.$message('请选择要删除的题目！');
          return false;
        };
      } else {
        that.topicNum = 0;
        that.removeID = e.id;
      }
      this.removeType = true;
    },

    removeHide(){
      this.removeType = false;
      this.remove_ids = [];
      this.removeID = '';
      this.topicNum = 0;
    },

    removeSub(){
      var that = this;
      if(this.topicNum>0){
        
        batchDelTopic({ids:this.remove_ids,cert_id:this.$route.query.id},this.token).then((res)=>{
          var data = res.data;
          if(data.code == 200){
            that.$message('批量删除成功!');
            that.removeType = false;
            that.resetSub();
            that.topicNum = 0;
          } else {
            that.$message(data.msg);
          }
        })
      } else {
        delTopic({id:this.removeID,cert_id:this.$route.query.id},this.token).then((res)=>{
          var data = res.data;
          if(data.code == 200){
            that.$message('删除成功!');
            that.removeType = false;
            that.resetSub();
          } else {
            that.$message(data.msg);
          }
        })
      }
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj = {
        cert_id:'',
        page:1,
        rows:10,
        type:'1-2-2'
      };
      this.addObj = {
        cert_id:'',
        cert_num:'',
        topic_title:'',
        topic_type:'',
        answer:[],
        analysis:'',
      };
      this.topicObj = {};
      var id = this.$route.query.id
      if(id){
        this.obj.cert_id = id;
        this.addObj.cert_id = id;
      }
      this.dataList = [];
      this.getList();
    },

    detailSub(e){
      var that = this;
      getTopicDetail({id:e.id},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.detailData = data.data;
          if(that.detailData.topic_type == 2){
            that.detailData.answer = JSON.parse(that.detailData.answer);
          };
          that.detailType = true;
        } else {
          that.$message(data.msg);
        }
      })
    },

    editShow(e){
      var that = this;
      getTopicDetail({id:e.id},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          if(data.data.option_A == ''){
            delete data.data.option_A
          } 
          if(data.data.option_B == ''){
            delete data.data.option_B
          } 
          if(data.data.option_C == ''){
            delete data.data.option_C
          } 
          if(data.data.option_D == ''){
            delete data.data.option_D
          } 
          if(data.data.option_E == ''){
            delete data.data.option_E
          } 
          if(data.data.option_F == ''){
            delete data.data.option_F
          } 
          if(data.data.option_G == ''){
            delete data.data.option_G
          } 
          if(data.data.option_H == ''){
            delete data.data.option_H
          }
          that.addObj = data.data;
          that.addObj.id = e.id;
          if(that.addObj.topic_type == 2){
            that.addObj.answer = JSON.parse(that.addObj.answer);
          };
          that.addObj.cert_id = that.$route.query.id;
          if(e.content){
            that.addObj.content = e.content;
          }
          that.topicObj = {
            cert_id:that.addObj.cert_id,
            cert_num:that.addObj.cert_num,
            big_topic_id:e.big_topic_id,
            content:e.content,
            id:that.addObj.id,
            topic_title:that.addObj.topic_title,
            topic_type:that.addObj.topic_type,
            option_num:that.addObj.option_num,
            option_A:data.data.option_A?data.data.option_A:'',
            option_B:data.data.option_B?data.data.option_B:'',
            option_C:data.data.option_C?data.data.option_C:'',
            option_D:data.data.option_D?data.data.option_D:'',
            option_E:data.data.option_E?data.data.option_E:'',
            option_F:data.data.option_F?data.data.option_F:'',
            option_G:data.data.option_G?data.data.option_G:'',
            option_H:data.data.option_H?data.data.option_H:'',
            answer:that.addObj.answer,
            analysis:that.addObj.analysis,
          };
          if(that.addObj.topic_type == 1 || that.addObj.topic_type == 2){
            var list = [];
            that.optionsList.forEach(function(item,index){
              if(item.id<=parseInt(that.addObj.option_num)){
                item.check = false;
                var str = 'option_' + item.value;
                if(str=='option_A'){
                  item.topic = that.addObj.option_A;
                } else if(str=='option_B'){
                  item.topic = that.addObj.option_B;
                } else if(str=='option_C'){
                  item.topic = that.addObj.option_C;
                } else if(str=='option_D'){
                  item.topic = that.addObj.option_D;
                } else if(str=='option_E'){
                  item.topic = that.addObj.option_E;
                } else if(str=='option_F'){
                  item.topic = that.addObj.option_F;
                } else if(str=='option_G'){
                  item.topic = that.addObj.option_G;
                } else if(str=='option_H'){
                  item.topic = that.addObj.option_H;
                };
                that.$set(that.addObj,str,'')
                list.push(item);
              }
            });
            that.optionsData = list;
            if(that.addObj.topic_type == 2){
              that.optionsData.forEach(function(item,index){
                that.addObj.answer.forEach(function(ele,num){
                  if(ele == item.value){
                    item.checked = true;
                  }
                })
              })
            };
          };
          
          that.singleType = 'edit';
        } else {
          that.$message(data.msg);
        }
      })
    },

    detailHide(){
      var that = this;
      that.detailType = false;
      that.detailData = '';
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      console.log(file)
    },
    handleSuccess(response, file, fileList){
      console.log(response.code == 400, file, fileList);
      var that = this;
      if(response.code == 200){
        that.$message('上传成功！');
        that.previewObj.file_name = response.data.file_name;
        $('.el-upload-list').removeClass('hide');
      } else {
        if(response.code == 400 || response.code == 500){
          that.$message(response.msg);
        }
        $('.el-upload-list').addClass('hide');
      };
      this.loading = false;
    },
    handleBefore(file){
      console.log(this.fileObj.cert_num,'===cert_num==');
      this.loading = true;
    },
    handleError(err, file, fileList){
      console.log(err,'==errr==')
      this.loading = false;
      this.$message('上传错误，请重新上传！');
    },


    optionsChange(e,i){
      var that = this;
      var list = [];
      console.log(i)
      if(i>=0){
        delete that.topicObj.topics[i].option_A;
        delete that.topicObj.topics[i].option_B;
        delete that.topicObj.topics[i].option_C;
        delete that.topicObj.topics[i].option_D;
        delete that.topicObj.topics[i].option_E;
        delete that.topicObj.topics[i].option_F;
        delete that.topicObj.topics[i].option_G;
        delete that.topicObj.topics[i].option_H;
      } else {
        delete that.addObj.option_A;
        delete that.addObj.option_B;
        delete that.addObj.option_C;
        delete that.addObj.option_D;
        delete that.addObj.option_E;
        delete that.addObj.option_F;
        delete that.addObj.option_G;
        delete that.addObj.option_H;
      }
      this.optionsList.forEach(function(item,index){
        if(item.id<=parseInt(e.target.value)){
          item.check = false;
          var str = 'option_' + item.value;
          if(i>=0){
            that.$set(that.topicObj.topics[i],str,'');
          } else {
            that.$set(that.addObj,str,'')
          }
          list.push(item);
        }
      });
      this.optionsData = list;
      if(i>=0){
        this.topicObj.topics[i].option_num = parseInt(e.target.value);
        this.topicObj.topics[i].optionsData = list;
      } else {
        this.addObj.option_num = parseInt(e.target.value);
      }
    },

    explainShow(){
      
      this.explainType = true;
    },  

    getList(){
      var that = this;
      getTopicList(that.obj,that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          data.data.list.forEach(function(item,index){
            // if(item.topic_type == 2){
            //   item.answer = JSON.parse(item.answer)
            // }
            
          });
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
          
        } else {
          that.$message(data.msg);
        }
      })
    },

    singleShow(){
      var that = this;
      this.singleType=true;
    },

    singleSub(){
      var that = this;
      if(this.addObj.content){
        this.updateCaseTopic();
        return false;
      }
      if(this.addObj.topic_type == 4){
        this.addCaseTopic();
        return false;
      }
      var list = [];
      this.optionsList.forEach(function(item,index){
          var str = 'option_' + item.value;
          if(item.topic){
            that.$set(that.addObj,str,item.topic);
          };
          if(that.addObj.topic_type == 2){
            if(item.checked){
              list.push(item.value);
            }
          }
      });
      
      if(that.addObj.topic_type == 2){
        this.addObj.answer = list;
      };
      if(this.addObj.cert_num == '' || this.addObj.cert_num == null){
        this.$message('请选择章节！');
        return false;
      };
      if(this.addObj.topic_type	 == ''){
        this.$message('请选择题目类型！');
        return false;
      };
      if(this.addObj.topic_title == ''){
        this.$message('请填写题干！');
        return false;
      };
      if(that.addObj.topic_type != 3 && !this.addObj.option_num){
        this.$message('请选择选项数量！！');
        return false;
      };
      if(that.addObj.topic_type != 3 && this.addObj.option_A==''){
        this.$message('请填写选项A！！');
        return false;
      };
      if(that.addObj.topic_type != 3 && this.addObj.option_B==''){
        this.$message('请填写选项B！！');
        return false;
      };
      if(that.addObj.topic_type != 3 && this.addObj.option_C==''){
        this.$message('请填写选项C！！');
        return false;
      };
      if(that.addObj.topic_type != 3 && this.addObj.option_D==''){
        this.$message('请填写选项D！！');
        return false;
      };
      if(that.addObj.topic_type != 3 && this.addObj.option_E==''){
        this.$message('请填写选项E！！');
        return false;
      };
      if(that.addObj.topic_type != 3 && this.addObj.option_F==''){
        this.$message('请填写选项F！！');
        return false;
      };
      if(that.addObj.topic_type != 3 && this.addObj.option_G==''){
        this.$message('请填写选项G！！');
        return false;
      };
      if(that.addObj.topic_type != 3 && this.addObj.option_H==''){
        this.$message('请填写选项H！！');
        return false;
      };
      if(this.addObj.answer == '' || this.addObj.answer == []){
        this.$message('请选择答案！');
        return false;
      };
      
      saveTopic(this.addObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code==200){
          that.$message('添加成功');
          that.resetSub();
          that.singleType = false;
        } else {
          that.$message(data.msg);
        }
      })
    },

    singleHide(){
      var that = this;
      this.resetSub();
      this.singleType = false;
    },

    addCaseTopic(){
      var that = this;
      this.topicObj.topics.forEach(function(item,index){
        if(item.topic_type == 2){
          item.answer = [];
          item.optionsData.forEach(function(ele,num){
            if(ele.checked){
              item.answer.push(ele.value);
            }
          });
        }
      })
      this.topicObj.cert_num = this.addObj.cert_num;
      this.topicObj.topics.forEach(function(item,index){
        delete item.optionsData;
      });
      if(this.topicObj.big_topic_id){
        delete this.topicObj.content;
      }
      addBigTopic(this.topicObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code==200){
          that.$message('添加成功');
          that.resetSub();
          that.singleType = false;
        } else {
          that.$message(data.msg);
        }
      })
      console.log(this.topicObj,'cccc')
    },

    updateCaseTopic(){
      var that = this;
      updateBigTopic(this.topicObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code==200){
          that.$message('编辑成功');
          that.resetSub();
          that.singleType = false;
        } else {
          that.$message(data.msg);
        }
      })
    },

    previewSub(){
      var that = this;
      if(that.previewObj.file_name == ''){
        that.$message('请先上传文件！');
        return false;
      };
      preview(this.previewObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code==200){
          that.multipleType = false;
          that.previewType = true;
          that.previewData = data.data.list;
          that.previewData.forEach(function(item,index){
            if(item.topic_type == 2){
              item.answer = JSON.parse(item.answer);
            }
          });
          that.previewPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
    },

    topicSub(){
      var that = this;
      var obj = {
        cert_id:this.obj.cert_id,
        file_name:that.previewObj.file_name
      };
      if(obj.file_name == ''){
        that.$message('请先上传文件！');
        return false;
      };
      submitImport(obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code==200){
          that.$message('提交成功！');
          that.resetSub();
          that.multipleType = false;
        } else {
          that.$message(data.msg);
        }
      })
    },

    backSub(){
      var that = this;
      // this.previewData = [];
      // this.fileObj={
      //   cert_id:'',
      //   cert_num:''
      // };
      this.previewType = false;
      this.multipleType = 'word';
    },

    checkLength(e) {
      var hidTitleWordNum = 30;
      var titleAreaVal = e;
      for (var i = 0; i < titleAreaVal.length; i++) {
        if ((titleAreaVal.charCodeAt(i) >= 0) && (titleAreaVal.charCodeAt(i) <= 255)) {
          this.textNum = this.textNum + 1;
        } else {
          this.textNum = this.textNum + 2;
        };
        if (this.textNum > hidTitleWordNum) {
          e = e.substring()
          // return false;
          // alert("输入数据超长！不能再输入数据。");
        } else {
          // alert('dd')
        };
      }
    },

    loadAll() {
        return [
        { "value": "[", "address": "[" },
      ];
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    querySearchAsync1(queryString, cb) {
      var restaurants = this.answerList;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      console.log(item);
    },


    templateDetail(type){
      this.templateType = true;
      this.restaurants = [
        { "value": "[", "address": "[" },
      ];
      this.answerList = [
        { "value": "解析，答案解析", "address": "解析，答案解析" },
      ];
    },

    templateHide(){
      this.templateType = false;
      // this.template_options = [];
      // this.templateObj = {
      //   cert_id:'',
      //   cert_num:'',
      //   large_section:['',''],
      //   subject:['',''],
      //   topic_mold:['',''],
      //   difficulty:['',''],
      //   score:['',''],
      //   title:['',''],
      //   answer:['',''],
      //   analysis:['','']
      // };
      // this.large_section_start = '';
      // this.large_section_end = '';
      // this.topic_mold_start = '';
      // this.topic_mold_end = '';
      // this.difficulty_start = '';
      // this.difficulty_end = '';
      // this.score_start = '';
      // this.score_end = '';
      // this.subject_start = '';
      // this.subject_end = '';
      // this.title_start = "";
      // this.title_end = "";
      // this.answer_start = "";
      // this.answer_end = "";
      // this.analysis_start = "";
      // this.analysis_end = "";
    },

    templateClose(){
      var that = this;
      this.templateObj.cert_id = this.obj.cert_id;
      this.templateObj.cert_num = this.fileObj.cert_num;

      // if(this.topic_mold_start == ''){
      //   that.$message('请填写题目类型-开始！');
      //   return false;
      // };
      // if(this.topic_mold_end == ''){
      //   that.$message('请填写题目类型-结束！');
      //   return false;
      // };


      if(this.subject_start == ''){
        that.$message('请填写题目至答案-开始！');
        return false;
      };
      if(this.subject_end == ''){
        that.$message('请填写题目至答案-结束！');
        return false;
      };
      if(this.title_start == ''){
        that.$message('请填写题干-开始！');
        return false;
      };
      if(this.title_start == ''){
        that.$message('请填写题干-结束！');
        return false;
      };

      this.templateObj.large_section = '["'+this.large_section_start+'","'+this.large_section_end+'"]';
      this.templateObj.subject = '["'+this.subject_start+'","'+this.subject_end+'"]';
      this.templateObj.topic_mold = '["'+this.topic_mold_start+'","'+this.topic_mold_end+'"]';
      this.templateObj.difficulty = '["'+this.difficulty_start+'","'+this.difficulty_end+'"]';
      this.templateObj.score = '["'+this.score_start+'","'+this.score_end+'"]';
      this.templateObj.title = '["'+this.title_start+'","'+this.title_end+'"]';

      if(this.subject_start == '' && this.subject_end == ''){
        delete this.templateObj.subject
      };
      if(this.topic_mold_start == '' && this.topic_mold_end == ''){
        delete this.templateObj.topic_mold
      };
      if(this.difficulty_start == '' && this.difficulty_start == ''){
        delete this.templateObj.difficulty
      };
      if(this.score_start == '' && this.score_start == ''){
        delete this.templateObj.score
      };
      
      
      var that = this;
      this.template_options.forEach(function(item,index){
          if(item.title == 'A'){
            that.templateObj.option_A = ['',''];
            that.templateObj.option_A = '["'+item.start+'","'+item.end+'"]';
          } else if(item.title == 'B'){
            that.templateObj.option_B = ['',''];
            that.templateObj.option_B = '["'+item.start+'","'+item.end+'"]';
          } else if(item.title == 'C'){
            that.templateObj.option_C = ['',''];
            that.templateObj.option_C = '["'+item.start+'","'+item.end+'"]';
          } else if(item.title == 'D'){
            that.templateObj.option_D = ['',''];
            that.templateObj.option_D = '["'+item.start+'","'+item.end+'"]';
          } else if(item.title == 'E'){
            that.templateObj.option_E = ['',''];
            that.templateObj.option_E = '["'+item.start+'","'+item.end+'"]';
          } else if(item.title == 'F'){
            that.templateObj.option_F = ['',''];
            that.templateObj.option_F = '["'+item.start+'","'+item.end+'"]';
          } else if(item.title == 'G'){
            that.templateObj.option_G = ['',''];
            that.templateObj.option_G = '["'+item.start+'","'+item.end+'"]';
          }
      });

      if(this.answer_start == ''){
        that.$message('请填写答案-开始！');
        return false;
      };
      if(this.answer_end == ''){
        that.$message('请填写答案-结束！');
        return false;
      };

      

      this.templateObj.answer = '["'+this.answer_start+'","'+this.answer_end+'"]';
      this.templateObj.analysis = '["'+this.analysis_start+'","'+this.analysis_end+'"]';

      if(this.analysis_start == '' && this.analysis_end == ''){
        delete this.templateObj.analysis
      };
      if(this.word_topicType == 4){
        this.templateObj.material = '["'+this.material_start+'","'+this.material_end+'"]';
      }
      this.templateType = false;
    },

    optionSub(e){
      var that = this;
      var list = [];
      that.template_options = [];
      list = e;
      list.forEach(function(item,index){
        that.template_options.push({title:item,start:'',end:''});
      });
      console.log(that.template_options)
    },

    templateSub(){
      this.templateObj.cert_id = this.obj.cert_id;
      this.templateObj.cert_num = this.fileObj.cert_num;

      if(this.topic_mold_start == ''){
        that.$message('请填写题目类型-开始！');
        return false;
      };
      if(this.topic_mold_end == ''){
        that.$message('请填写题目类型-结束！');
        return false;
      };
      if(this.subject_start == ''){
        that.$message('请填写题目至答案-开始！');
        return false;
      };
      if(this.subject_end == ''){
        that.$message('请填写题目至答案-结束！');
        return false;
      };
      if(this.title_start == ''){
        that.$message('请填写题干-开始！');
        return false;
      };
      if(this.title_start == ''){
        that.$message('请填写题干-结束！');
        return false;
      };

      this.templateObj.large_section.push(this.large_section_start);
      this.templateObj.large_section.push(this.large_section_end);
      this.templateObj.subject.push(this.subject_start);
      this.templateObj.subject.push(this.subject_end);
      this.templateObj.topic_mold.push(this.topic_mold_start);
      this.templateObj.topic_mold.push(this.topic_mold_end);
      this.templateObj.difficulty.push(this.difficulty_start);
      this.templateObj.difficulty.push(this.difficulty_end);
      this.templateObj.score.push(this.score_start);
      this.templateObj.score.push(this.score_end);
      this.templateObj.title.push(this.title_start);
      this.templateObj.title.push(this.title_end);

      var that = this;
      this.template_options.forEach(function(item,index){
          if(item.title == 'A'){
            that.templateObj.option_A = [];
            that.templateObj.option_A.push(item.start);
            that.templateObj.option_A.push(item.end);
          } else if(item.title == 'B'){
            that.templateObj.option_B = [];
            that.templateObj.option_B.push(item.start);
            that.templateObj.option_B.push(item.end);
          } else if(item.title == 'C'){
            that.templateObj.option_C = [];
            that.templateObj.option_C.push(item.start);
            that.templateObj.option_C.push(item.end);
          } else if(item.title == 'D'){
            that.templateObj.option_D = [];
            that.templateObj.option_D.push(item.start);
            that.templateObj.option_D.push(item.end);
          } else if(item.title == 'E'){
            that.templateObj.option_E = [];
            that.templateObj.option_E.push(item.start);
            that.templateObj.option_E.push(item.end);
          } else if(item.title == 'F'){
            that.templateObj.option_F = [];
            that.templateObj.option_F.push(item.start);
            that.templateObj.option_F.push(item.end);
          } else if(item.title == 'G'){
            that.templateObj.option_G = [];
            that.templateObj.option_G.push(item.start);
            that.templateObj.option_G.push(item.end);
          }
      });

      if(this.answer_start == ''){
        that.$message('请填写答案-开始！');
        return false;
      };
      if(this.answer_end == ''){
        that.$message('请填写答案-结束！');
        return false;
      };

      this.templateObj.answer.push(this.answer_start);
      this.templateObj.answer.push(this.answer_end);
      this.templateObj.analysis.push(this.analysis_start);
      this.templateObj.analysis.push(this.analysis_end);

      console.log(this.templateObj)
      importWordTopic(this.templateObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code==200){
          
        } else {
          that.$message(data.msg);
        }
      })
    },

    inputSub(type,e){
      if(type == 'large_section_start'){
        this.templateObj.large_section.push(e);
      };
      console.log(this.templateObj.large_section);
    },

    fileSub(type){
      this.multipleType = type;
    },

    getContent(){
      var that = this;
      if(this.addObj.cert_num == ''){
        that.$message('请选择章节');
        return false;
      }
      getBigTopicList({cert_id:this.addObj.cert_id,cert_num:this.addObj.cert_num},this.token).then((res)=>{
        var data = res.data;
        if(data.code==200){
          that.materialData = data.data;
          that.materialType = true;
        } else {
          that.$message(data.msg);
        }
      })
    },

    topicChange(type,i){
      if(type == 'anli'){
        console.log(this.topicObj.topics,'anli');
        return false;
      }
      var obj = {
        cert_id:this.addObj.cert_id,
        cert_num:'',
        content:'',
        topics:[
          {
            topic_title:'',
            answer:'',
            analysis:''
          }
        ]
      };
      this.topicObj = obj;
      console.log(obj);
    },

    addTopic(){
      var list = {
        topic_title:'',
        answer:'',
        analysis:''
      }
      this.topicObj.topics.push(list);
    },

    materialSub(e){
      this.topicObj.big_topic_id = e.big_topic_id;
      this.topicObj.content = e.content;
    },

    materialHide(){
      this.materialType = false;
    }
  },

  
};
</script>
<style scoped>
.el-upload{
  width: 60px;
  height: 60px;
}
.dataList .listItem p,
.organiza-list p{
  width: 8%;
}

.dataList .listItem p:nth-of-type(4),
.organiza-list p:nth-of-type(4){
  width: 20%;
}

.list-topic span{
  margin: 5px;
  display: block;
}

.previewBox .dataList .listItem p,
.previewBox .organiza-list p{
  width: 20%;
}
.organiza-title .btnBox{
  float: left;
  margin-left: 20px;
}

.organiza-title .btnBox .btn{
  margin-right: 20px;
}

.content1{
  background-color: #fff;
}

.content1 .form-txt {
  margin-bottom: 20px;
}

.content1 .form-txt .title{
  font-size: 14px;
  color: #3D3D3D;
  line-height: 36px;
  height: 36px;
  display: inline-block;
  vertical-align: top;
  width: 200px;
}

.content1 .form-txt .txt{
  display: inline-block;
  vertical-align: top;
}

.content1 .form-txt .txt p{
  color: #9C9EAA;
  font-size: 12px;
  margin: 10px 0;
}

.content1 .form-txt .btn-choose{
  margin-left: 20px;
  height: 36px;
  line-height: 36px;
  background-color: #457AFF;
  border-radius: 10px;
  color: #fff;
  padding: 0 5px;
  font-size: 14px;
  display: inline-block
}

.content1 .form-txt textarea{
  width: 300px;
  height: 150px;
  border-radius: 6px;
  background-color: #F7F9FA;
  padding: 10px 20px;
  border: solid 1px #ccc;
}

.content1 .form-txt .txt input{
  height: 36px;
  line-height: 36px;
  border-radius: 6px;
  background-color: #F7F9FA;
  padding: 10px 20px;
  display: inline-block;
  vertical-align: top;
}

.content1 .form-txt .txt p{
  height: 36px;
  line-height: 36px;
  display: inline-block;
  vertical-align: top;
  margin: 0;
  font-size: 14px;
}

.content1 .form-txt select{
  line-height: 36px;
  height: 36px;
  border: solid 1px #BFC3CD;
  border-radius: 6px;
  padding: 10px 20px;
}

.content1 .organiza-txt{
  overflow-y: auto;
  overflow-x: hidden;
}

.content1 .btnBox{
  font-size: 0;
  width: 100%;
  margin-top: 20px;
}

.content1 .btnBox .btn{
  width: 135px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  border-radius: 30px;
  font-size: 16px;
  display: inline-block;
  vertical-align: top;
  background-color: #CBCBCB;
}

.content1 .btnBox .btn-sub{
  background-color: #4C7EFB;
  margin: 0 80px;
}

.content1 .btnBox .btn-preview{
  background-color: transparent;
  border: solid 1px #457AFF;
  color: #457AFF;
}

.upload{
  display: block;
  margin: 10px 0 20px;
}

.organiza-txt{
  overflow-y: auto;
  overflow-x: hidden;
}

.previewBox .organiza-txt{
  overflow: hidden;
  height: calc( 100% - 120px );
}

.form-options{
  width: 100%;
  font-size: 0;
}

.form-options .form-txt{
  width: 50%;
  display: inline-block;
  vertical-align: top;
}

.content1 .form-txt3 .txt p{
  display: block;
  color: #3D3D3D;
}

.content1 .form-txt .txt label{
  height: 36px;
  line-height: 36px;
  display: block;
}

.content1 .form-txt .txt label input{
  padding: 0;
  margin: 0;
}

.content1 .form-txt .txt label.el-checkbox{
  display: inline-block;
}

.content1 .form-txt .txt label.el-radio{
  display: inline-block;
}

.content1 .el-radio-group{
  margin-right: 20px;
}

.file .form-txt .title{
  display: block;
}

.file .form-txt .btn{
  color: #457AFF;
  margin-right: 10px;
  font-size: 14px;
  display: inline-block;
}

.file .form-txt .txt{
  display: block;
  margin-top: 18px;
}

.file .form-txt .txt a{
    font-size: 14px;
    color: #457AFF;
}

.content1 .file .form-txt .title{
  width: 200px;
}

.templateBox .template-data,
.templateBox p{
  font-size: 15px;
  display: inline-block;
}

.templateBox .template-data{
  margin: 0 10px 0px 0;
}

.templateBox p.title{
  font-size: 24px;
  font-weight: bold;
}

.templateBox .template-data p{
  margin-right: 10px;
}

.templateBox .writeBox{
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}

.templateBox .write-item span{
  font-size: 12px;
  display: block;
  margin-bottom: 10px;
  text-align: left;
  color: #E2231A;
}

.fileType{
  float: left;
  width: 100%;
  margin-top: 10px;
}

.fileType span{
  display: inline-block;
  font-size: 14px;
  color: #3D3D3D;
  line-height: 36px;
  border: solid 1px #3D3D3D;
  border-radius: 5px;
  padding: 0px 10px;
  margin-right: 10px;
  background-color: transparent;
  border: solid 1px #457AFF;
  color: #457AFF;
}

.fileType span.select{
  background-color: #4C7EFB;
  color: #fff;
}

.materialBox .contv{
  width: 50%;
  height: 80%;

}

.materialBox .list{
  font-size: 0;
  height: 80%;
  text-align: center;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 30px;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.materialBox .list .list-item{
  font-size: 0;
  border: solid 1px #ccc;
  border-radius: 5px;
  padding: 10px 20px;
  text-align: left;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.materialBox .list .list-item.select{
  background-color: #457AFF;
  border-color: none;
}

.materialBox .list .list-item.select p{
  color: #fff;
}

.materialBox .list .list-item p{
  font-size: 14px;
  color: #333;
}

.templateBox .btnBox{
  margin-top: 10px;
}

.msg-txt{
  display: block;
  font-size: 12px;
  color: #ccc;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/topic/index.vue